<template>
  <div class="page-box">
    <div class="success-header">
      <div class="icon-circle">
        <span class="checkmark">✓</span>
      </div>
      <span class="success-text">支付成功</span>
    </div>

    <div class="order-detail">
      <div class="detail-title">支付订单详情</div>
      <div class="detail-item">支付金额：{{ amount }}元</div>
      <div class="detail-item">支付订单号：{{ outTradeNo }}</div>
      <div class="detail-item">支付状态：成功</div>
    </div>

    <div class="invoice-btn" @click="goInvoice">查看发票</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        outTradeNo: '',
        amount: ''
      }
    },
    mounted() {
      let initData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE',
        height: 960
      }
      parent.postMessage(JSON.stringify(initData), '*')

      const link = location.href
      this.outTradeNo = this.getQueryString(link, 'out_trade_no')
      this.amount = this.getQueryString(link, 'amount') || '0'

    },
    methods: {
      getQueryString(path, name) {
        const reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
        if (reg.test(path)) {
          return unescape(RegExp.$2.replace(/\+/g, ' '))
        }
        return ''
      },
      goInvoice() {
        var mchData = {
          action: 'jumpOut',
          jumpOutUrl: location.origin + '/cashier/invoice'
        }
        parent.postMessage(JSON.stringify(mchData), '*')
      }
    }
  }
</script>

<style scoped>
  .page-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 120px 48px 80px;
    background: #f5f5f5;
    min-height: 100vh;
  }

  .success-header {
    display: flex;
    align-items: center;
    margin-bottom: 80px;
  }

  .icon-circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #07c160;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 24px;
  }

  .checkmark {
    color: #fff;
    font-size: 48px;
    font-weight: bold;
  }

  .success-text {
    font-size: 44px;
    font-weight: 600;
    color: #333;
  }

  .order-detail {
    width: 100%;
    background: #fff;
    border-radius: 16px;
    padding: 40px 48px;
    margin-bottom: 40px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .detail-title {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    margin-bottom: 32px;
  }

  .detail-item {
    font-size: 28px;
    color: #666;
    line-height: 2;
  }

  .invoice-btn {
    width: 320px;
    height: 88px;
    background: #3b5bdb;
    border-radius: 8px;
    color: #fff;
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 40px;
  }

  .invoice-btn:active {
    opacity: 0.85;
  }
</style>
